import { render, staticRenderFns } from "./course.view.vue?vue&type=template&id=49ab038f&scoped=true"
import script from "./course.view.vue?vue&type=script&lang=js"
export * from "./course.view.vue?vue&type=script&lang=js"
import style0 from "./course.view.vue?vue&type=style&index=0&id=49ab038f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ab038f",
  null
  
)

export default component.exports